import * as React from "react";
import { dropdownViewGet } from "../service/api-service";
import { Dropdown } from "primereact/dropdown";
import { FormControl, FormLabel } from "@mui/joy";
import { InputText } from "primereact/inputtext";
import { Grid } from "@mui/material";
import { Input, Select } from "./Shared/Forms";

interface inputPrams {
  label: string;
  selectedValue: string;
  setSelectedValue: React.Dispatch<string>;
  selectedInterval: string;
  setSelectedInterval: React.Dispatch<string>;
  required?: boolean;
  disabled?: boolean;
}

const interval = [
  {
    id: "Hours",
  },
  {
    id: "Days",
  },
  {
    id: "Weeks",
  },
  {
    id: "Months",
  },
  {
    id: "Years",
  },
];

export default function IntervalDropdown(params: inputPrams) {
  const setSelected = (event: any) => {
    params.setSelectedInterval(event);
  };

  return (
    <div>
      <label className="block mb-2">
        {params.label}
        {params.required ? <div style={{ color: "red" }}>*</div> : ""}
      </label>
      <div className="p-inputgroup " style={{ height: 35 }}>
        <Input
          placeholder={params.label}
          type={"number"}
          value={params.selectedValue}
          onChange={e => params.setSelectedValue(e.target.value)}
        />
        <Select
          options={interval.map(item => ({
            label: item.id,
            value: item.id,
          }))}
          onChange={e => setSelected(e.value)}
          placeholder={"Interval"}
          value={params.selectedInterval}
          className={"w-40"}
        />
      </div>
    </div>
  );
}
